import { useQuery } from "@apollo/client/react";
import { USER_DOCUMENTS } from "@/hooks";

/**
 * Hook to fetch user documents
 * @param {Object} variables - Filter variables for the query
 * @param {string} variables.energyType - Energy type filter
 * @param {string} variables.subsidiary - Subsidiary filter
 * @param {string} variables.customer - Customer filter
 * @param {string} variables.tenant - Tenant filter
 * @param {string} variables.documentId - Document ID filter
 * @returns {Object} - Query result with data, loading, error, and refetch
 */
export const useUserDocuments = (variables = {}) => {
  const { data, loading, error, refetch } = useQuery<any>(USER_DOCUMENTS, {
    variables,
  });

  return {
    documents: data?.userDocuments || [],
    loading,
    error,
    refetch,
  };
};
